import { render, staticRenderFns } from "./InvestmentValuationForm.vue?vue&type=template&id=3d4bc3cc&scoped=true"
import script from "./InvestmentValuationForm.vue?vue&type=script&lang=js"
export * from "./InvestmentValuationForm.vue?vue&type=script&lang=js"
import style0 from "./InvestmentValuationForm.vue?vue&type=style&index=0&id=3d4bc3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bc3cc",
  null
  
)

export default component.exports